// frontend/src/components/grid/SorAwareTooltip.jsx
//
// AG Grid tooltip wrapper for SoR read-only columns whose OWN tooltip is a
// custom component (e.g. PromotionPriceTooltip). A custom tooltipComponent is
// column-level, so it also fires on a row where the ERP owns the column's
// domain — where withSorReadOnly's tooltipValueGetter has put the
// "managed in <ERP>" text on params.value. Without this wrapper that text would
// be handed to the domain-specific component (which renders its own thing, or
// nothing), so the read-only explanation would silently not show on those
// columns. This wrapper renders the message for ERP-owned rows and delegates to
// the original component for every other row.
//
// Columns WITHOUT a custom component don't need this — AG Grid's built-in text
// tooltip already renders params.value.
//
// Reads the role inline (not via useSoR's isErpOwned) so this stays a leaf with
// no import back into sorColumns, where withSorReadOnly composes it in.

import './TooltipCard.css';

export function makeSorAwareTooltip(OriginalComponent, domain) {
  return function SorAwareTooltip(props) {
    if (props.data?.sor?.[domain]?.role === 'ERP') {
      // Same box styling as the app's other custom tooltips.
      return <div className="tooltip-card">{props.value}</div>;
    }
    return <OriginalComponent {...props} />;
  };
}
